import { useState } from "react";

export function useEnrollmentForm(initialState = {}) {
    const [formData, setFormData] = useState(initialState);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // section, field, value
    const handleFormChange = (section, field, value) => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value,
            },
        }));
    };

    const resetForm = () => setFormData(initialState);

    // Generic submit handler for API calls
    const onSubmit = async (apiFunction) => {
        setIsSubmitting(true);
        try {
            const response = await apiFunction();
            setIsSubmitting(false);
            return response;
        } catch (error) {
            setIsSubmitting(false);
            throw error;
        }
    };

    return { formData, handleFormChange, resetForm, onSubmit, isSubmitting };
}
